<div class="dialog_container how-it-works-dialog">
  <div class="header_row">
    <h4>{{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.TITLE' | translate }}</h4>
    <mat-icon class="close" (click)="close()">close</mat-icon>
  </div>

  <mat-tab-group
    [(selectedIndex)]="activeTabIndex"
    class="how-it-works-tabs"
    animationDuration="300ms"
  >
    <!-- Step by Step Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label">
          {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_BY_STEP_TAB' | translate }}
        </span>
      </ng-template>
      <div class="tab-content step-by-step-content">
        <h2 class="main-title">
          {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.MAIN_TITLE' | translate }}
        </h2>

        <div class="steps-container">
          <!-- Step 1 -->
          <div class="step-item">
            <div class="step-number">1</div>
            <div class="step-content">
              <h3 class="step-title">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_1.TITLE' | translate }}
              </h3>
              <p class="step-description">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_1.DESCRIPTION' |
                translate }}
              </p>
            </div>
          </div>

          <!-- Step 2 -->
          <div class="step-item">
            <div class="step-number">2</div>
            <div class="step-content">
              <h3 class="step-title">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_2.TITLE' | translate }}
              </h3>
              <p class="step-description">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_2.DESCRIPTION' |
                translate }}
              </p>
            </div>
          </div>

          <!-- Step 3 -->
          <div class="step-item">
            <div class="step-number">3</div>
            <div class="step-content">
              <h3 class="step-title">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_3.TITLE' | translate }}
              </h3>
              <p class="step-description">
                {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.STEP_3.DESCRIPTION' |
                translate }}
              </p>
            </div>
          </div>
        </div>

        <div class="dialog__footer">
          <app-generic-button-with-arrow
            (onClick)="onCreateTaskClick()"
            [label]="'COMPONENTS.HOW_IT_WORKS_DIALOG.CREATE_TASK_BUTTON' | translate"
          ></app-generic-button-with-arrow>
        </div>
      </div>
    </mat-tab>

    <!-- Video Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="tab-label">
          {{ 'COMPONENTS.HOW_IT_WORKS_DIALOG.VIDEO_TAB' | translate }}
        </span>
      </ng-template>
      <div class="dialog__panel">
        @if (language == 'nl') {
        <div
          class="videoWrapper"
          style="padding: 56.25% 0 0 0; position: relative"
        >
          <iframe
            src="https://player.vimeo.com/video/1162959628?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            title="Handyhand uitlegvideo"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
            allowfullscreen
          ></iframe>
        </div>
        } @else if (language == 'da') {
        <div
          class="videoWrapper"
          style="padding: 56.25% 0 0 0; position: relative"
        >
          <iframe
            src="https://player.vimeo.com/video/1143806020?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            [title]="'COMPONENTS.HOW_IT_WORKS_VIDEO.IFRAME_TITLE' | translate"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
            allowfullscreen
          ></iframe>
        </div>
        } @else {
        <div
          class="videoWrapper"
          style="padding: 75% 0 0 0; position: relative"
        >
          <iframe
            src="https://player.vimeo.com/video/1143801710?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            title="Handyhand Explainer English"
            style="
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
            "
            allowfullscreen
          ></iframe>
        </div>
        }
        <div class="dialog__footer">
          <app-generic-button-with-arrow
            (onClick)="onCreateTaskClick()"
            [label]="'COMPONENTS.HOW_IT_WORKS_DIALOG.CREATE_TASK_BUTTON' | translate"
          ></app-generic-button-with-arrow>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
